import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Radio,
  Grid
} from "@material-ui/core";
import React from "react";
import { makeStyles, withStyles } from "@material-ui/styles";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";

const useStyle = makeStyles((theme) => ({
  body: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 3),
    columnGap: theme.spacing(4),
  },
  formControl: {
    marginLeft: theme.spacing(6),
  },
  formControlLabel: {
    "& .MuiFormControlLabel-label": {
      fontWeight: "bold",
    },
  },
  accessBox: {
    display: "flex",
    flexFlow: "column",
  },
  publishButton: {
    color: theme.palette.common.white,
  },
  scrollContainer: {
    maxHeight: "70vh",
    overflowY: "auto",
    backgroundColor: "#f3f3f3",
  },
}));

const Accordion = withStyles({
  root: {
    paddingTop: "4px",
    paddingBottom: "4px",
    borderBottom: 0,
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    minHeight: 36,
    "&$expanded": {
      minHeight: 36,
      borderBottom: "1px solid #d9d9d9",
    },
  },
  content: {
    margin: "0px 0",
    "&$expanded": {
      margin: "0px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: "unset",
  },
}))(MuiAccordionDetails);

export default function AccessRightControlPanelComponent({
  features,
  enabled,
  onChange,
  disabled,
  layer,
}) {
  const classes = useStyle();

  return (
    <Box>
      {features.map((module) => (
        <Box mb={1} style={{ border: '1px solid #d9d9d9', borderRadius: '6px' }}>
          <Accordion style={{ width: "100%", borderRadius: '6px' }}>
            <AccordionSummary
              expandIcon={module?.subModules?.length > 0 || module?.functions?.length > 0
                ? <ExpandMoreIcon />
                : null
              }
            >
              <FormControlLabel
                onClick={(event) => event.stopPropagation()}
                onFocus={(event) => event.stopPropagation()}
                control={
                  <Checkbox
                    disabled={disabled}
                    checked={enabled[module.name]}
                    indeterminate={(() => {
                      const enableSubmodule = Object.keys(enabled).filter((feature) => feature.startsWith(`${module.name}.`) && feature.split('.').length === 2 && enabled[feature]);
                      return enableSubmodule.length > 0 && enableSubmodule.length < module.subModules.length;
                    })()}
                  />
                }
                onChange={(event) => {
                  onChange(`${module.name}`, event.target.checked);
                }}
                label={module.title}
                className={classes.formControlLabel}
              />
            </AccordionSummary>
            {((module.functions && module.functions.length > 0) || (module.subModules && module.subModules.length > 0)) && (
              <AccordionDetails>
                <Box display="flex" flexDirection="column" py={1} width="100%">
                  {module.functions && module.functions.length > 0 ? (
                    <Box px={2} display="flex" flexDirection="column">
                      {module.functions.map((func) => (
                        <>
                          <FormControlLabel
                            onClick={(event) => event.stopPropagation()}
                            onFocus={(event) => event.stopPropagation()}
                            control={
                              <Radio
                                disabled={disabled}
                                checked={
                                  enabled[`${module.name}.${func.name}`]
                                }
                              />
                            }
                            onClickCapture={(event) => {
                              onChange(`${module.name}.${func.name}`, event.target.checked, true);
                            }}
                            label={func.title}
                            className={classes.formControlLabel}
                          />
                          {(func.actions ?? []).map((action) => (
                            <>
                              <FormControlLabel
                                style={{ marginLeft: 20 }}
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={
                                  <Checkbox
                                    disabled={disabled}
                                    checked={
                                      enabled[`${module.name}.${func.name}.${action.name}`]
                                    }
                                  />
                                }
                                onClickCapture={(event) => {
                                  onChange(`${module.name}.${func.name}.${action.name}`, event.target.checked, true);
                                }}
                                label={action.title}
                                className={classes.formControlLabel}
                              />
                              {(action.subActions ?? []).map((subAction) => (
                                <>
                                  <FormControlLabel
                                    style={{ marginLeft: 50 }}
                                    onClick={(event) => event.stopPropagation()}
                                    onFocus={(event) => event.stopPropagation()}
                                    control={
                                      <Checkbox
                                        disabled={disabled}
                                        checked={
                                          enabled[`${module.name}.${func.name}.${action.name}.${subAction.name}`]
                                        }
                                      />
                                    }
                                    onClickCapture={(event) => {
                                      onChange(`${module.name}.${func.name}.${action.name}.${subAction.name}`, event.target.checked, true);
                                    }}
                                    label={subAction.title}
                                    className={classes.formControlLabel}
                                  />
                                </>
                              ))}
                            </>
                          ))}
                        </>
                      ))}
                    </Box>
                  ) : (
                    <>
                      {module.subModules.map((subModule, index) => (
                        <Box px={2}>
                          <Grid container>
                            <Grid item xs={5}>
                              <Box display="flex" height="100%">
                                <Box flexGrow={1} pr={2} py={1}>
                                  <FormControlLabel
                                    onClick={(event) => event.stopPropagation()}
                                    onFocus={(event) => event.stopPropagation()}
                                    control={
                                      <Checkbox
                                        disabled={disabled}
                                        checked={enabled[`${module.name}.${subModule.name}`]}
                                      />
                                    }
                                    onChange={(event) => {
                                      onChange(`${module.name}.${subModule.name}`, event.target.checked);
                                    }}
                                    label={subModule.title}
                                    className={classes.formControlLabel}
                                  />
                                </Box>
                                {layer > 2 && (
                                  <Divider flexItem orientation="vertical" sx={{ borderStyle: 'dashed' }} />
                                )}
                              </Box>
                            </Grid>
                            <Grid item xs={7}>
                              <Box pl={2} py={1} display="flex" flexDirection="column">
                                {(subModule.functions ?? []).map((func) => (
                                  <>
                                    <FormControlLabel
                                      onClick={(event) => event.stopPropagation()}
                                      onFocus={(event) => event.stopPropagation()}
                                      control={
                                        <Radio
                                          disabled={disabled}
                                          checked={
                                            enabled[`${module.name}.${subModule.name}.${func.name}`]
                                          }
                                        />
                                      }
                                      onClickCapture={(event) => {
                                        onChange(`${module.name}.${subModule.name}.${func.name}`, event.target.checked, true);
                                      }}
                                      label={func.title}
                                      className={classes.formControlLabel}
                                    />
                                    {(func.actions ?? []).map((action) => (
                                      <>
                                        <FormControlLabel
                                          style={{ marginLeft: 20 }}
                                          onClick={(event) => event.stopPropagation()}
                                          onFocus={(event) => event.stopPropagation()}
                                          control={
                                            <Checkbox
                                              disabled={disabled}
                                              checked={
                                                enabled[`${module.name}.${subModule.name}.${func.name}.${action.name}`]
                                              }
                                            />
                                          }
                                          onClickCapture={(event) => {
                                            onChange(`${module.name}.${subModule.name}.${func.name}.${action.name}`, event.target.checked, true);
                                          }}
                                          label={action.title}
                                          className={classes.formControlLabel}
                                        />
                                        {(action.subActions ?? []).map((subAction) => (
                                          <>
                                            <FormControlLabel
                                              style={{ marginLeft: 50 }}
                                              onClick={(event) => event.stopPropagation()}
                                              onFocus={(event) => event.stopPropagation()}
                                              control={
                                                <Checkbox
                                                  disabled={disabled}
                                                  checked={
                                                    enabled[`${module.name}.${subModule.name}.${func.name}.${action.name}.${subAction.name}`]
                                                  }
                                                />
                                              }
                                              onClickCapture={(event) => {
                                                onChange(`${module.name}.${subModule.name}.${func.name}.${action.name}.${subAction.name}`, event.target.checked, true);
                                              }}
                                              label={subAction.title}
                                              className={classes.formControlLabel}
                                            />
                                          </>
                                        ))}
                                      </>
                                    ))}
                                  </>
                                ))}
                              </Box>
                            </Grid>
                          </Grid>
                          {(layer > 2 && module.subModules.length - 1 > index) && (
                            <Divider sx={{ borderStyle: 'dashed' }} />
                          )}
                        </Box>
                      ))}
                    </>
                  )}
                </Box>
              </AccordionDetails>
            )}
          </Accordion>
        </Box>
      ))}
    </Box>
  );
}
